import { type IntegrationServiceId } from '../../../../common/integrations'
import { type CrossClientQueryDataSource } from '../../../../models/CrossClient'
import { getCrossClientIntegrationDisplayName } from '../../integrationDisplay'

export const getCrossClientResultDetailSourceLabel = (source: CrossClientQueryDataSource): string => {
  if (source.type === 'clientProfile') {
    return 'Zocks - Client Profile'
  }

  if (source.type === 'meeting') {
    return 'Zocks - Meetings'
  }

  return getCrossClientResultSourceLabel(source)
}

export const getCrossClientResultSourceLabel = (source: CrossClientQueryDataSource): string => {
  if (source.type === 'integration') {
    return getCrossClientIntegrationDisplayName(source.integrationType as IntegrationServiceId)
  }

  return ''
}

export const sortSources = (sources: CrossClientQueryDataSource[]): CrossClientQueryDataSource[] => [...sources].sort((a, b) => a.type.localeCompare(b.type))
